import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { FaArrowRight, FaFilePdf } from "react-icons/fa";

const IndustrySearchReport = () => {
  const pageTitle = "Industry Search Report";
  const docs = [
    {
      year: "2024",
      date: "23 September, 2026",
      url: "/assets/pdf/Industry_search_Report/India Real Estate Advisory Brokerage Underwriting and Leasing Market Outlook to 2030F_BlackOpal_11092026_Final 1 1.pdf",
      image: "/assets/img/Report_1.png",
      name: "Industry Search Report"
    }
  ];

  const renderDocs = (docsList) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mt-2 mb-5 px-5">
      {docsList.map((doc, index) => (
        <div
          key={index}
          className="bg-white border-1 border-[#989898] rounded-lg shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition flex flex-col"
          onClick={() => window.open(doc.url, "_blank")}
        >
          {/* Top Thumbnail */}
          <div className="!h-36 w-full border-b border-[#989898] bore !overflow-hidden bg-gray-100">
            <img
              src={doc.image}
              alt={`Report ${doc.year}`}
              className="!w-full !h-full !object-fill"
            />
          </div>

          {/* Bottom Content  */}
          <div className="px-2 mt-1 -mb-3 bg-white">
            <div className="!flex !items-center !justify-between">
              <div className="!flex !gap-2 items-center">
                <FaFilePdf className="!text-red-600 !text-lg" />
                <p className="!font-medium !text-sm !items-center max-w-[150px] whitespace-normal break-words">
                  {doc.name}
                </p>
              </div>
              <div className="bg-gray-200 p-1 rounded-full">
                <FaArrowRight className="text-[#F26624] text-sm" />
              </div>
            </div>

            <p className="!text-gray-500 !text-xs !-mt-3 !ml-7">{doc.date}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <div className="main-content">
        <Header />
        {/* Banner Section */}
        <div
          className="relative w-full h-64 md:h-80 lg:h-96"
          style={{
            backgroundImage: `url(/assets/img/Financial_banner.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        >
        </div>

        {/* Page Content */}
        <div className="flex flex-col py-2 overflow-hidden -mt-2">
          {/* Top Section: Full-width Background Image with Text on Left */}
          <h2 className="text-2xl !font-semibold mt-5 px-5 !text-[#F26624]">
            Industry Search Report
          </h2>

          {renderDocs(docs)}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default IndustrySearchReport;
